import { IconButton, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { useEffect, useState } from 'react'

import { getTranslate } from '../localization'

const useStyles = makeStyles((theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    marginBottom: 16,
    backgroundColor: '#e3f2fd',
    borderRadius: 4
  },
  icon: {
    marginRight: 8,
    color: '#1565c0'
  },
  text: {
    flex: 1,
    color: theme.palette.text.primary
  }
}))

export default function SessionExpiredBanner() {
  const classes = useStyles()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (localStorage.getItem('sessionExpired') === 'true') {
      setVisible(true)
      localStorage.removeItem('sessionExpired')
    }
  }, [])

  if (!visible) return null

  return (
    <Paper className={classes.banner} elevation={0}>
      <InfoOutlinedIcon className={classes.icon} />
      <Typography variant="body2" className={classes.text}>
        {getTranslate(
          'Your session has expired due to inactivity. Please log in again.'
        )}
      </Typography>
      <IconButton
        size="small"
        onClick={() => setVisible(false)}
        aria-label={getTranslate('Dismiss')}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Paper>
  )
}
